"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductData = exports.getProductDataFromObject = void 0;
var Product_1 = __importDefault(require("../models/Product"));
var getMetaProp_1 = __importDefault(require("./getMetaProp"));
exports.getProductDataFromObject = function (product, sku, color, quantity) {
    if (quantity === void 0) { quantity = 1; }
    var currency = '';
    var reviewsEnabled = false;
    if (typeof (window.__STATE__) !== 'undefined') {
        currency = window.__STATE__.localization.currency;
        reviewsEnabled = window.__STATE__.functions.reviews;
    }
    var productRow = new Product_1.default(sku);
    productRow.name = product.name;
    productRow.inStock = product.availability.can_be_bought
        ? 'in stock'
        : 'out of stock';
    productRow.unitPrice = product.price;
    var oldPriceMeta = product.catalog_price === product.price ? null : product.catalog_price;
    var oldPrice;
    productRow.discountPercentage = '';
    if (oldPriceMeta === null) {
        oldPrice = productRow.unitPrice;
    }
    else {
        oldPrice = oldPriceMeta;
        if (oldPrice !== 0) {
            var discount = ((1 - (productRow.unitPrice / oldPrice)) * 100).toFixed(0);
            productRow.discountPercentage = discount + "%";
        }
    }
    productRow.basePrice = oldPrice;
    productRow.currency = currency;
    if (reviewsEnabled) {
        productRow.ratings = product.rating ? parseFloat(product.rating.average.toFixed(2)) : 0;
        productRow.nbBVreviews = product.rating ? product.rating.count.toString() : '';
    }
    productRow.referenceWrapper = product.id.toString();
    if (product.flags.new) {
        productRow.sticker1 = 'Nouveau';
    }
    else if (product.flags.bestseller) {
        productRow.sticker1 = 'Bestseller';
    }
    productRow.sticker2 = productRow.discountPercentage !== '' ? 'Discount' : '';
    productRow.isGift = false;
    if (color) {
        productRow.color = color.attribute_name;
    }
    else if (typeof (product.attributes) !== 'undefined') {
        product.attributes.forEach(function (attribute) {
            if (attribute.sku === sku) {
                productRow.color = attribute.attribute_name;
            }
        });
    }
    productRow.set = 'none';
    productRow.quantity = quantity;
    var rootCategoryName = '';
    if (product.main_category !== null) {
        for (var _i = 0, _a = product.main_category.path; _i < _a.length; _i++) {
            var category = _a[_i];
            if (category.url === null) {
                continue;
            }
            rootCategoryName = category.name;
            break;
        }
    }
    productRow.category = rootCategoryName;
    return productRow;
};
exports.getProductData = function (product) {
    var sku = getMetaProp_1.default(product, 'sku');
    if (sku === null) {
        return null;
    }
    var productRow = new Product_1.default(sku);
    productRow.name = getMetaProp_1.default(product, 'name') || '';
    productRow.inStock = getMetaProp_1.default(product, 'availability') === 'http://schema.org/OutOfStock'
        ? 'out of stock'
        : 'in stock';
    productRow.unitPrice = parseFloat(getMetaProp_1.default(product, 'price') || '0');
    var oldPriceMeta = getMetaProp_1.default(product, 'oldPrice');
    var oldPrice;
    productRow.discountPercentage = '';
    if (oldPriceMeta === null) {
        oldPrice = productRow.unitPrice;
    }
    else {
        oldPrice = parseFloat(oldPriceMeta);
        if (oldPrice !== 0) {
            var discount = ((1 - (productRow.unitPrice / oldPrice)) * 100).toFixed(0);
            productRow.discountPercentage = discount + "%";
        }
    }
    productRow.basePrice = oldPrice;
    productRow.currency = (getMetaProp_1.default(product, 'priceCurrency') || '').toLowerCase();
    productRow.ratings = parseFloat(getMetaProp_1.default(product, 'ratingValue') || '0');
    productRow.nbBVreviews = getMetaProp_1.default(product, 'reviewCount') || '';
    productRow.referenceWrapper = getMetaProp_1.default(product, 'wrapperId') || '';
    if (product.querySelector('img[src*="f_new"]') !== null) {
        productRow.sticker1 = 'Nouveau';
    }
    else if (product.querySelector('img[src*="f_bestseller"]') !== null) {
        productRow.sticker1 = 'Bestseller';
    }
    productRow.sticker2 = productRow.discountPercentage !== '' ? 'Discount' : '';
    productRow.isGift = getMetaProp_1.default(product, 'isGift') === '1';
    productRow.color = getMetaProp_1.default(product, 'color') || '';
    productRow.set = getMetaProp_1.default(product, 'setType') || 'none';
    var quantity = getMetaProp_1.default(product, 'quantity');
    productRow.quantity = 1;
    if (quantity !== null) {
        productRow.quantity = parseInt(quantity, 10);
    }
    var categoryName = getMetaProp_1.default(product, 'category');
    if (categoryName !== null) {
        productRow.category = categoryName;
    }
    return productRow;
};
